/* eslint-disable no-debugger */
import React, { Fragment } from 'react';

import useClubMeetSanctionRequestV2 from './UseClubMeetSanctionRequestV2';

import MeetSanctionInfoFormV2 from './forms/MeetSanctionInfoFormV2';
import MeetSanctionStaffFormV2 from './forms/MeetSanctionStaffFormV2';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Headings from '@usas/ui-web/components/headings/Headings';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import SessionsGrid from '@usas/ui-web/components/meetSessions/SessionsGrid';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';
import Constants from '@usas/ui-web/utils/Constants';
import global from '@usas/ui-web/components/GlobalStyle.module.css'
import MeetSessionsDetailFormV2 from './forms/MeetSessionsDetailFormV2';

const ClubMeetSanctionRequestV2 = () => {
  const {
    isSaving,
    isLoading,
    meetState,
    displayMeetInfoFormState,
    displayMeetSessionsFormState,
    displayMeetSessionsDetailFormState,
    displayStaffFormState,
    meetInfoState,
    meetSessionsState,
    meetStaffState,
    facilityOptionsState,
    orgUnitId,
    onInfoFormSubmit,
    onSessionsFormSubmit,
    onStaffFormSubmit,
    onBackToMeetInfoClicked,
    onBackToMeetSessionsClicked,
    onBackToMeetSessionsFromDetail,
    onAddSession,
    onEditSession,
    onDeleteSession,
    onDeleteSessionClicked,
    onModalCanceled,
    onCancelClicked,
    state, 
    setState,
    OFFICIAL_ORG_ROLE_ID,
    OFFICIALS_ROLES_ROLE_GROUP_ID,
    selectedMeetClassificationState,
    hasUsasSanctionAccess
  } = useClubMeetSanctionRequestV2();

  return (
    <Fragment>
      {displayMeetInfoFormState === true &&
        <Fragment>
          <div className="row">
            <div className="col-xs-12">
              <Headings.H3>Meet Sanction Request - Meet Info</Headings.H3>
            </div>
          </div>
          <MeetSanctionInfoFormV2
            savedFormState={meetInfoState}
            clubFacilities={facilityOptionsState}
            orgUnitId={orgUnitId}
            onSubmitFormCallback={onInfoFormSubmit}
            onCancelClicked={onCancelClicked}
            state={state}
            setState={setState}
            meetState={meetState}
            selectedMeetClassificationId={selectedMeetClassificationState?.id || Constants.DEFAULT_ID}
            selectedMeetClassificationName={selectedMeetClassificationState?.name || ''}
            hasUsasSanctionAccess={hasUsasSanctionAccess}
          />
        </Fragment>
      }
      {displayMeetSessionsFormState === true &&
        <Fragment>
          <div className="row">
            <div className="col-xs-12">
              <Headings.H3>Meet Sanction Request - Sessions</Headings.H3>
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-12 usas-extra-top-margin'>
              <ActionIntraPageButton onClick={onAddSession}>Add Session</ActionIntraPageButton>
            </div>
            <div className='col-xs-12 usas-extra-bottom-margin'>
              <SessionsGrid
                showOptionalFields={false}
                sortedMeetSessionArray={meetSessionsState.sortedMeetSessionArray}
                onEdit={onEditSession}
                onDelete={onDeleteSession}
                onDeleteClicked={onDeleteSessionClicked}
              />
            </div>
          </div>
          {meetSessionsState.errorState?.error &&
            <div className="row">
              <div className="col-xs-12">
                <p className={global.ErrorMessage}>{meetSessionsState.errorState?.error ? meetSessionsState.errorState?.error : ''}</p>
              </div>
            </div>
          }
          <div className="row">
            <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
              <PrimaryButton type="button" onClick={() => onSessionsFormSubmit()}>Continue</PrimaryButton>&nbsp;
              <SecondaryButton type="button" onClick={() => onBackToMeetInfoClicked()}>Back</SecondaryButton>
            </div>
          </div>
          <PopUpModal
            widthPct={90}
            maxWidth={720}
            title={meetSessionsState?.modalState?.modalTitle}
            displayPopUp={meetSessionsState?.modalState?.displayPopUp}
            onModalCanceled={onModalCanceled}>
            <div className="row">
              <div className="col-xs-12">
                <p><b>Session Number:</b>&nbsp;{meetSessionsState?.modalState?.sessionOrderId}</p>
                <p><b>Session Type:</b>&nbsp;{meetSessionsState?.modalState?.sessionTypeName}</p>
                <p><b>Session Date:</b>&nbsp;{meetSessionsState?.modalState?.sessionDate ? formatDate(meetSessionsState?.modalState?.sessionDate) : ''}</p>
              </div>
              <div className="col-xs-12 usas-extra-top-margin">
                <PrimaryButton type="button" onClick={(e) => onDeleteSession(e, meetSessionsState?.modalState?.meetSessionId)}>Delete</PrimaryButton>&nbsp;
                <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>
              </div>
            </div>
          </PopUpModal>
        </Fragment>
      }
      {displayMeetSessionsDetailFormState === true &&
        <Fragment >
          <div className="row">
            <div className="col-xs-12">
              <Headings.H3>Meet Sanction Request - {meetSessionsState.formState.meetSessionId > 0 ? 'Edit' : 'Add'} Session</Headings.H3>
            </div>
          </div>
          <MeetSessionsDetailFormV2
            onBackToMeetSessions={onBackToMeetSessionsFromDetail}
          />
        </Fragment>}
      {displayStaffFormState === true &&
        <Fragment>
          <div className="row">
            <div className="col-xs-12">
              <Headings.H3>Meet Sanction Request - Staff</Headings.H3>
            </div>
          </div>
          <MeetSanctionStaffFormV2
            savedFormState={meetStaffState}
            onSubmitFormCallback={onStaffFormSubmit}
            onBackClicked={onBackToMeetSessionsClicked}
            OFFICIAL_ORG_ROLE_ID={OFFICIAL_ORG_ROLE_ID}
            OFFICIALS_ROLES_ROLE_GROUP_ID={OFFICIALS_ROLES_ROLE_GROUP_ID} 
            meetInfoState={meetInfoState}
          />
        </Fragment>
      }
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title="Submitting Request..."
        displayPopUp={isSaving} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment >
  );
};

export default ClubMeetSanctionRequestV2;